//general states to be used used througout app
export const STATE = Object.freeze({
  LOADING: "loading",
  WARNING: "warning",
  ERROR: "error",
  COMPLETED: "completed",
  SELECTED: "selected",
  NOT_SELECTED: "not selected",
});
